import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "font-converter",
  title: "Font Converter",
  description:
    "Convert font files in bulk between web and desktop formats, then download ready-to-use outputs.",
  category: "Design",
} satisfies ToolMeta;
